
import { Card } from "@/components/ui/card";
import { Cloud } from "lucide-react";

interface Keyword {
  text: string;
  size: number;
}

interface TrendingKeywordsProps {
  keywords: Keyword[];
}

export const TrendingKeywords = ({ keywords }: TrendingKeywordsProps) => (
  <Card className="p-6 bg-zinc-800/20 border-zinc-700">
    <h3 className="text-lg font-semibold mb-4 flex items-center gap-2 text-white">
      <Cloud className="w-5 h-5" />
      Trending Keywords
    </h3>
    <div className="flex flex-wrap gap-2">
      {keywords.length === 0 ? (
        <div className="text-zinc-400">No trending keywords yet</div>
      ) : (
        keywords.map((keyword, index) => (
          <span
            key={index}
            style={{ fontSize: `${keyword.size / 16}rem` }}
            className="text-violet-400 hover:text-violet-300 transition-colors cursor-default"
          >
            {keyword.text}
          </span>
        ))
      )}
    </div>
  </Card>
);
